export default class RegisterController {
    constructor($scope, $http, toast) {
        'ngInject';

        this.$scope = $scope;
        this.$http = $http;
        this.toast = toast;

        this.data = {
            tax_id: null,
            company_name: null,
            address: null,
            city: null,
            postal_code: null,
            country_id: null
        };
    }

    getGusReportByTaxId() {
        const _this = this;

        this.$http.post('/api/register/get-gus-report-by-tax-id', {
            tax_id: this.data.tax_id
        }).then((response) => {
            _this.data = response.data.data;
        }, (response) => {
            _this.toast.create({
                message: response.data.message,
                className: 'alert-danger'
            });
        });
    }
}